import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import BrokerList from '@/modules/broker/views/BrokerList.vue'
import BrokerApprovalList from '@/modules/broker/views/BrokerApprovalList.vue'

const baseRoute = OneNetworkConfig.baseRoutePath
const accountRouter = [
  {
    path: `${baseRoute}/broker/list`,
    name: 'broker-list',
    meta: {
      component: BrokerList
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/broker/approval`,
    name: 'broker-approval',
    meta: {
      component: BrokerApprovalList
    },
    component: PrivateRouter,
  },
]
export default accountRouter
